import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

function PersonSearch({
  cpfCnpjValue,
  nomeFantasiaValue,
  razaoSocialValue,
}) {
  return (
    <>
      <label id="title">Dados do Cliente</label>
      <div className="rowContainer">
        <div className="inputHolder">
          <span>CPF / CNPJ *</span>
          <input
            disabled
            id="cpfCnpj"
            type="text"
            name="cpfCnpj"
            value={cpfCnpjValue}
          />
        </div>
        <div className="inputHolder defaultFlex">
          <span>Razão Social *</span>
          <input
            disabled
            id="razao"
            type="text"
            name="razao"
            value={razaoSocialValue}
          />
        </div>
      </div>
      <div className="rowContainer">
        <div className="inputHolder defaultFlex">
          <span>Nome Fantasia *</span>
          <input
            disabled
            id="name"
            type="text"
            name="name"
            value={nomeFantasiaValue}
          />
        </div>
      </div>
    </>
  );
}

PersonSearch.propTypes = {
  cpfCnpjValue: PropTypes.string.isRequired,
  nomeFantasiaValue: PropTypes.string.isRequired,
  razaoSocialValue: PropTypes.string.isRequired,
};

export default PersonSearch;
